import * as React from 'react';

const SvgComponent = _props => {
  const {'aria-label': ariaLabel, role, alt, ...rest} = _props;
  const props = {
    ...rest,
    ...(ariaLabel || alt
      ? {
          role: role || 'img',
          'aria-label': ariaLabel,
          alt
        }
      : {
          'aria-hidden': 'true'
        })
  };
  return (
    <svg viewBox="0 0 77 75" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.124 0C6.324 0 0 6.296 0 14.063v46.874C0 68.704 6.324 75 14.124 75h48.752C70.676 75 77 68.704 77 60.937V14.063C77 6.295 70.677 0 62.876 0H14.124zm9.71 17.39c-1.846-1.703-4.76-1.703-6.508 0-1.846 1.704-1.846 4.542 0 6.34l11.462 11.165a4.784 4.784 0 006.509 0c1.748-1.798 1.748-4.637 0-6.34L23.834 17.391zm17.773 11.165c-1.749 1.798-1.749 4.636 0 6.34 1.748 1.703 4.663 1.703 6.508 0L59.578 23.73c1.748-1.798 1.748-4.636 0-6.34-1.846-1.703-4.76-1.703-6.509 0L41.607 28.556zM17.328 51.263c-1.748 1.798-1.748 4.637 0 6.34 1.749 1.703 4.663 1.703 6.509 0l11.462-11.165c1.748-1.798 1.748-4.636 0-6.34-1.846-1.702-4.76-1.702-6.508 0L17.328 51.264zM41.614 40.1c1.748-1.703 4.663-1.703 6.508 0l11.463 11.164c1.748 1.704 1.748 4.542 0 6.34-1.749 1.703-4.663 1.703-6.509 0L41.614 46.438c-1.846-1.798-1.846-4.636 0-6.34z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgComponent;
